export const Locale = {
    EN: 'en',
    FR: 'fr',
    JA: 'ja',
    ID: 'id',
    DA: 'da',
    DE: 'de',
    NL: 'nl',
    FI: 'fi',
    SV: 'sv',
    PLATFORM_DEFAULT: 'p_def'
};

export const LocaleMap = {
    en: 'en_US',
    fr: 'fr_CA',
    ja: 'ja_JP',
    id: 'id_ID',
    da: 'da_DK',
    de: 'de_DE',
    nl: 'nl_NL',
    fi: 'fi_FI',
    sv: 'sv_SE'
};
